import * as actionTypes from '../actions/actionType';

export default (state = [], action) => {
    switch (action.type) {

        case actionTypes.CREATE_NEW_CONTACT:
            return [
                ...state,
                Object.assign({}, action.contact)
            ];

        case actionTypes.REMOVE_CONTACT:
            return state.filter((data, i) => i !== action.id);

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/contactReducer.js